import { SessionAuth } from "./Auth";
import { ConvertedAccount } from "./ConvertedAccount";
import { DeletedAccount } from "./DeletedAccount";
import { SessionEmailConfirmation } from "./Email";
import { LegalInformation } from "./LegalInformation";
import { SessionAuth0 } from "./Login";
import { SessionLogout } from "./Logout";
import { SessionPasswordReset } from "./Password/Reset";
import { SessionPasswordSetup } from "./Password/Setup";
import { AgreementsComponent, SessionSignUpEmailVerify } from "./SignUpUser";
import { UnsubscribePage } from "./Unsubscribe";

export const pages = {
  "deleted-account": DeletedAccount,
  "converted-account": ConvertedAccount,
  oauth: SessionAuth0,
  auth: SessionAuth,
  "register-email-verify": SessionSignUpEmailVerify,
  logout: SessionLogout,
  "password-reset": SessionPasswordReset,
  "password-setup": SessionPasswordSetup,
  "email-confirmation": SessionEmailConfirmation,
  "legal-information": LegalInformation,
  agreement: AgreementsComponent,
  unsubscribe: UnsubscribePage,
};
